/*
 * Public API Surface of messages
 */

export * from './components/ngkit-inline-message.component';
export type { NgkitInlineMessageAction, MessageSeverity } from './components/ngkit-inline-message.component';
export type { NgkitInlineMessageButton } from './interfaces/ngkit-inline-message-button';
export type { NgkitInlineMessageLink } from './interfaces/ngkit-inline-message-link';
